export const nativeSymbols = {
  Ethereum: 'ETH',
  BSC: 'BNB',
  Polygon: 'MATIC',
  Kava: 'KAVA',
};